import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environemnts/environment';
import { AuthService } from './auth.service';


@Injectable()
export class CookieInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const { userSessionInfo } = this.injector.get(AuthService);
  
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const isRestApiRequest = event.url?.startsWith(environment.baseUrl)
            || event.url?.startsWith(environment.ASAPAbaseUrl);

          if (isRestApiRequest) {
            // console.log('REST response:', {
            //   methodName: event.url,
            //   requestType: req.method,
            //   response: event.body,
            //   userSessionInfo: userSessionInfo
            // });
          }

          const cookies = event.headers.get('set-cookie');
          if (cookies) {
            console.log('Cookies:', cookies);
            // Store the cookie as needed
          }
        }
      })
    );
  }
}